import { SxProps } from '@mui/material';

import { themeColors } from '@/config/theme/themeColors.ts';

export const NewEmailStyles: SxProps = {
  background: themeColors.bg,
  height: '100%',
  overflowX: 'auto',
  width: '100%',
  zIndex: 1000,
};

export const NewEmailHeaderStyles: SxProps = {
  alignItems: 'center',
  background: themeColors.white,
  borderBottom: `1px solid ${themeColors.grey}`,
  display: 'flex',
  justifyContent: 'space-between',
  position: 'sticky',
  px: 4,
  py: 1,
  top: 0,
  zIndex: 2,
};

export const NewEmailFormStyles: SxProps = {
  background: themeColors.white,
  pb: 5,
  pt: 1,
  px: 4,
};
export const NewEmailBeingSentStyles: SxProps = {
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  left: 0,
  position: 'absolute',
  top: 0,
  width: '100%',
};
